import { createFileRoute } from '@tanstack/react-router'
import AllPlansPage from '#/pages/AllPlansPage'
import { plansQueryOptions } from '#/features/plans/hooks/usePlans'
import { faqsQueryOptions } from '#/features/faqs/hooks/useFaqs'
import { coursesQueryOptions } from '#/features/courses/hooks/useCourses'

export const Route = createFileRoute('/_home/plans')({
  loader: async ({ context: { queryClient } }) => {
    await Promise.all([
      queryClient.ensureQueryData(plansQueryOptions()),
      queryClient.ensureQueryData(faqsQueryOptions()),
      queryClient.ensureQueryData(coursesQueryOptions({ limit: 5 })),
    ])
  },
  head: () => ({
    meta: [
      {
        title: "Tuition Plans & Pricing | Wa'allamah",
      },
      {
        name: 'description',
        content:
          "Affordable, flexible tuition plans for 1-on-1 Quran recitation, Tajweed, and Islamic studies at Wa'allamah.",
      },
    ],
  }),
  component: AllPlansPage,
})
